/* eslint-disable react/prop-types */
/* eslint-disable import/extensions */
/* eslint-disable global-require */
/* eslint-disable import/no-unresolved */
import React, { ReactChild, ReactElement } from "react";
import { styled, theme } from "../theme/theme";

import { ImageIcon } from "./icon";

export type ButtonProps = {
  children: ReactChild;
  disabled?: boolean;
  icon?: ReactChild;
  onClick: () => void;
  variant: "black" | "grayLightest" | "grayDarkest" | "green";
};

export const ChipButton = styled.button<ButtonProps>`
  align-items: center;
  background: ${({ variant }) => {
    switch (variant) {
      case "grayLightest":
        return theme.color.grayLightest;
      case "grayDarkest":
        return theme.color.grayDarkest;
      default:
        return theme.color.grayDarkest;
    }
  }};
  border-radius: ${() => {
    return theme.spacing.xxl;
  }};
  border: 2px solid
    ${({ variant }) => {
      switch (variant) {
        case "grayLightest":
          return theme.color.grayLightest;
        default:
          return theme.color.grayDarkest;
      }
    }};
  color: ${({ variant }) => {
    switch (variant) {
      case "grayLightest":
        return theme.color.grayDarkest;
      default:
        return theme.color.white;
    }
  }};
  cursor: ${({ disabled }) => {
    return !disabled && "pointer";
  }};

  box-shadow: ${({ disabled }) => {
    return !disabled && `0px 2px 4px rgba(46, 53, 56, 0.25)`;
  }};

  display: flex;
  font-family: ${() => {
    return theme.fontFamily;
  }};
  font-size: ${() => {
    return theme.fontSize.xs;
  }};
  font-weight: 800;
  letter-spacing: ${() => {
    return theme.letterSpacing.s;
  }};
  line-height: 15px;
  padding: ${() => {
      return theme.spacing.xs;
    }}
    ${() => {
      return theme.spacing.xs;
    }};
  text-transform: uppercase;

  @media only screen and (max-width: 420px) {
    height: 48px;
    font-size: ${() => {
      return theme.fontSize.xxs;
    }};
  }
`;

const InlineButtonIcon = styled(ImageIcon)``;

const ButtonLabel = styled.span`
  color: ${() => {
    return theme.color.white;
  }};
  font-size: ${() => {
    return theme.fontSize.xs;
  }};
  font-weight: 800;
  letter-spacing: 0.5px;
  line-height: 15px;
  margin: 0;
  max-width: 0;
  overflow: hidden;
  text-transform: uppercase;
`;

const HoverButtonWrapper = styled(ChipButton)`
  border-radius: ${() => {
    return theme.radius.xxxl;
  }};
  border: none;
  height: 48px;
  max-height: 48px;
  min-width: 48px;
  min-width: 48px;
  white-space: nowrap;

  opacity: ${({ disabled }) => {
    return disabled && "0.38";
  }};

  &:hover,
  &:focus {
    background: ${() => {
      return theme.color.black;
    }};

    ${ButtonLabel} {
      max-width: 800px;
      margin-right: ${() => {
        return theme.spacing.s;
      }};
      transition: ${() => {
        return theme.transitionSpeed.verySlow;
      }};
    }
  }
`;

const IconButton = ({
  children,
  disabled,
  onClick,
  variant = "grayDarkest",
}: ButtonProps): ReactElement => {
  return (
    <HoverButtonWrapper disabled={disabled} variant={variant} onClick={onClick}>
      <>
        <ButtonLabel>{children}</ButtonLabel>
        <InlineButtonIcon image={require(`../svg/cog.svg`)} size="small" />
      </>
    </HoverButtonWrapper>
  );
};

export default IconButton;
